const HTTP_response = function (xhr) {
  this.xhr = xhr
  this.body = xhr.response
  this.status = xhr.status
  this.headers = xhr.getAllResponseHeaders().split("\r\n").reduce((result, current) => {
    let [name, value] = current.split(': ');
    result[name] = value;
    return result;
  })
  this.parser = new DOMParser();
}

HTTP_response.prototype.header = function (key) {
  return this.headers[key];
}

HTTP_response.prototype.json = function () {
  return JSON.parse(this.body)
}

HTTP_response.prototype.dom = function () {
  return this.parser.parseFromString(this.body, "text/html")
}

export function request (method, url, {headers, body, options} = {})
{
  const req = new_request(method, url, {headers, body, options});
  return req.send();
}

export function new_request (method, url, {headers, body, options} = {})
{
  const xhr = new XMLHttpRequest()
  return {

    url: function () {
      return url;
    },

    method: function () {
      return method
    },

    send: function () {
      //xhr.withCredentials = true;
      xhr.open(method, url, true)

      xhr.setRequestHeader("X-Requested-With", "XMLHttpRequest");
//			xhr.setRequestHeader("Content-Type", "application/json")

      for (const key in headers)
      {
        if (Object.hasOwnProperty.call(headers, key))
        {
          xhr.setRequestHeader(key, headers[key])
        }
      }

      if (options && options.hasOwnProperty("checkProgress"))
      {
        xhr.upload.onprogress = options.checkProgress
      }

      xhr.send(body)

      return new Promise((resolve, reject) => {
        xhr.onload = function () {
          resolve(new HTTP_response(xhr))
        }

        xhr.onerror = function () {
          reject(new HTTP_error(xhr))
        }

        xhr.onabort = function () {
          reject(new HTTP_error(xhr))
        }
      })
    }
  }
}

const HTTP_error = function (xhr) {
  this.status = xhr.status
  this.body = xhr.response
  this.headers = xhr.getAllResponseHeaders().split("\r\n").reduce((result, current) => {
    let [name, value] = current.split(': ');
    result[name] = value;
    return result;
  })
}

HTTP_error.prototype.toString = function () {
  let json = JSON.parse(this.body)
  return "[" + this.status + "] Error: " + json.error || json.errors.join(", ")
}


export function send (method, url, data, headers = {})
{
  const request = new XMLHttpRequest()

  return new Promise((resolve, reject) => {

    try
    {
      request.open(method, url, true);
    } catch (e)
    {
      reject(new Error('error opening xhr: ' + e.message))
    }

    request.setRequestHeader("X-Requested-With", "XMLHttpRequest")

    request.onreadystatechange = function () {
      if (request.readyState === XMLHttpRequest.DONE)
      {
        if (request.status >= 200 && request.status < 300)
        {
          resolve(request)
        }
        else
        {
          reject(new Error('' + request.status))
        }
      }
    }

    request.onerror = () => {
      reject(new Error('network error ' + url))
    }

    for (let k in headers)
    {
      const v = headers[k]
      if (v != null)
      {
        request.setRequestHeader(k, v);
      }
    }

    // TODO credentials
    // TODO mime type
    // TODO timeout handling
    // TODO if data is FormData

    try
    {
      request.send(data)
    } catch (e)
    {
      request.onreadystatechange = null
      reject(new Error('error sending xhr ' + e.message))
    }
  })
}